import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

const HERO_IMAGES = [
  { src: '/images/image1.png', alt: 'Seas Heating and AC - HVAC services Las Vegas' },
  { src: '/images/image2.png', alt: 'Professional HVAC service - Seas Heating and AC' },
  { src: '/images/image3.png', alt: 'Heating and cooling solutions - Las Vegas' },
  { src: '/images/image4.png', alt: 'Trusted HVAC company - Seas Heating and AC' },
];

export default function Home() {
  const [heroIndex, setHeroIndex] = useState(0);

  useEffect(() => {
    document.title = 'Seas Heating and AC | HVAC Services Las Vegas';
  }, []);

  const goPrev = useCallback(() => {
    setHeroIndex((i) => (i === 0 ? HERO_IMAGES.length - 1 : i - 1));
  }, []);
  const goNext = useCallback(() => {
    setHeroIndex((i) => (i === HERO_IMAGES.length - 1 ? 0 : i + 1));
  }, []);

  useEffect(() => {
    const timer = setInterval(goNext, 6000);
    return () => clearInterval(timer);
  }, [goNext]);

const featureCards = [
  {
    title: 'No Upfront Payments',
    description: 'Flexible financing options available. Get the comfort you need without the financial stress.',
    icon: (
      <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    title: 'Satisfaction Guarantee',
    description: 'We stand behind our work. If you\'re not happy, we\'ll make it right—no questions asked.',
    icon: (
      <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11" />
      </svg>
    ),
  },
  {
    title: 'Emergency Service',
    description: 'HVAC emergencies don\'t wait. We offer fast response times when you need us most.',
    icon: (
      <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    title: '19 Years Experience',
    description: 'Nearly two decades of HVAC expertise. We\'ve seen it all and know how to fix it.',
    icon: (
      <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
      </svg>
    ),
  },
];

  return (
    <>
      {/* Hero Carousel */}
      <section className="relative min-h-[500px] lg:min-h-[600px] flex items-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          {HERO_IMAGES.map((img, i) => (
            <div
              key={img.src}
              className={`absolute inset-0 transition-opacity duration-500 ${i === heroIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
            >
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/40" />
            </div>
          ))}
        </div>

        {/* Carousel arrows */}
        <button
          type="button"
          onClick={goPrev}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white/90 shadow-md flex items-center justify-center text-seas-gray hover:bg-white hover:shadow-lg transition-all focus:outline-none focus:ring-2 focus:ring-seas-gold"
          aria-label="Previous slide"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
        </button>
        <button
          type="button"
          onClick={goNext}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white/90 shadow-md flex items-center justify-center text-seas-gray hover:bg-white hover:shadow-lg transition-all focus:outline-none focus:ring-2 focus:ring-seas-gold"
          aria-label="Next slide"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
        </button>

        {/* Dot indicators */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {HERO_IMAGES.map((_, i) => (
            <button
              key={i}
              type="button"
              onClick={() => setHeroIndex(i)}
              className={`w-2.5 h-2.5 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-white ${i === heroIndex ? 'bg-seas-gold scale-125' : 'bg-white/70 hover:bg-white'}`}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-xl">
            <div className="bg-white/95 backdrop-blur p-8 lg:p-10 shadow-xl">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-seas-gray uppercase tracking-tight leading-tight mb-4">
                Keeping Your Home Comfortable All Year Long
              </h1>
              <p className="text-gray-600 mb-6">
                Professional heating, cooling, and maintenance so your air conditioning and heating systems run reliably all year.
              </p>
              <Link
                to="/contact"
                className="inline-block bg-seas-gold text-white font-semibold px-8 py-3 rounded hover:bg-amber-600 transition-colors uppercase tracking-wide"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Feature Cards */}
      <section className="py-14 lg:py-20 bg-gray-50/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 -mt-24 relative z-10">
            {featureCards.map((card) => (
              <div
                key={card.title}
                className="bg-white p-6 shadow-md rounded-xl flex flex-col items-center text-center hover:shadow-lg hover:-translate-y-0.5 transition-all border border-gray-100"
              >
                <div className="text-seas-blue mb-4">{card.icon}</div>
                <h3 className="font-bold text-seas-gray text-lg mb-2">{card.title}</h3>
                <p className="text-gray-600 text-sm">{card.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
            <div>
              <p className="text-seas-blue/80 text-sm font-semibold uppercase tracking-widest mb-2">
                Our Services
              </p>
              <h2 className="text-3xl lg:text-4xl font-bold text-seas-gray tracking-tight">
                What We Can Offer You
              </h2>
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center px-6 py-3 border-2 border-seas-gold text-seas-gray font-semibold rounded-lg hover:bg-seas-gold hover:text-white transition-colors shrink-0"
            >
              Get a Quote
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="h-[280px] overflow-hidden rounded-xl">
              <img src="/images/offer-image1.png" alt="Heating services - Seas Heating and AC" className="w-full h-full object-contain" />
            </div>
            <div className="h-[280px] overflow-hidden rounded-xl">
              <img src="/images/offer-image2.png" alt="Cooling services - Seas Heating and AC" className="w-full h-full object-cover" />
            </div>
            <div className="h-[280px] overflow-hidden rounded-xl">
              <img src="/images/offer-image3.png" alt="Maintenance and repair - Seas Heating and AC" className="w-full h-full object-cover" />
            </div>
          </div>

          <p className="mt-8 text-gray-600 text-center max-w-2xl mx-auto">
            From furnace repairs to full AC installations, Seas Heating and AC handles it all. 
            <Link to="/services" className="text-seas-blue font-medium hover:underline ml-1">View all services →</Link>
          </p>
        </div>
      </section>

      {/* Why Choose Us - more content + image section */}
      <section className="py-16 lg:py-24 bg-gray-50/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-seas-blue/80 text-sm font-semibold uppercase tracking-widest text-center mb-2">Why Us</p>
          <h2 className="text-3xl font-bold text-seas-gray text-center mb-12 tracking-tight">Why Choose Seas Heating and AC?</h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-gray-600 mb-4 leading-relaxed">
                We're not a faceless corporation. When you call, you reach Seas—a Las Vegas native with 19 years in the trade. 
                That means honest diagnostics, fair pricing, and work you can count on. We treat every home like our own because 
                this community is our home.
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-center gap-2"><span className="text-seas-gold">✓</span> Same-day and emergency service when you need it</li>
                <li className="flex items-center gap-2"><span className="text-seas-gold">✓</span> Upfront pricing—no surprise fees</li>
                <li className="flex items-center gap-2"><span className="text-seas-gold">✓</span> Licensed, insured, and fully credentialed</li>
                <li className="flex items-center gap-2"><span className="text-seas-gold">✓</span> Residential and light commercial</li>
              </ul>
            </div>
            <img src="/images/choose-image1.png" alt="Why choose Seas Heating and AC - Las Vegas HVAC" className="min-h-[320px] w-full object-cover rounded-xl" />
          </div>
        </div>
      </section>

      {/* Service area / CTA strip + image section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <img src="/images/choose-image2.png" alt="Serving Las Vegas Valley - Seas Heating and AC" className="min-h-[300px] w-full object-cover rounded-xl" />
            <div>
              <p className="text-seas-blue/80 text-sm font-semibold uppercase tracking-widest mb-2">Service Area</p>
              <h2 className="text-2xl lg:text-3xl font-bold text-seas-gray mb-4 tracking-tight">Serving the Las Vegas Valley</h2>
              <p className="text-gray-600 mb-6">
                From Summerlin to Henderson, North Las Vegas to the Strip corridor, we're your local HVAC team. 
                Whether you need a quick repair or a full system install, we're just a call away. 
                Schedule a free estimate or same-day service—we're here when you need us.
              </p>
              <Link to="/contact" className="inline-block bg-seas-gold text-white font-semibold px-6 py-3 rounded hover:bg-amber-600 transition-colors">
                Schedule a Visit
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
